export default __webpack_public_path__ + "static/media/audio-file.a6cb4e3d.svg";